import { FormattedMessage } from 'react-intl'
import { useNavigate } from '@tanstack/react-router'

import { useDealNavigationPokerSitesList } from '@/api/gen'

import { HeaderNavDropdown } from './header-nav-dropdown'

export const HeaderNavigationSites = () => {
  const navigate = useNavigate()
  const { data, isFetching } = useDealNavigationPokerSitesList()

  const options =
    Array.isArray(data) && data.length && !isFetching
      ? [
          {
            label: <FormattedMessage id="common.controls.allDeals" />,
            onClick: () => navigate({ to: '/app/deals' }).catch(console.error),
          },
          ...data.map((site) => ({
            label: site.name,
            onClick: () => navigate({ to: `/app/deals/${site.slug ?? ''}` }).catch(console.error),
          })),
        ]
      : [
          {
            label: (
              <FormattedMessage
                id={isFetching ? 'common.labels.loading' : 'common.labels.noDeals'}
              />
            ),
          },
        ]

  return (
    <HeaderNavDropdown
      label={<FormattedMessage id="common.labels.pokerDeals" />}
      options={options}
      onLabelClick={() => {
        navigate({ to: '/app/deals' }).catch(console.error)
      }}
    />
  )
}
